import React from 'react';
import PropTypes from 'prop-types';
import styles from './footer.module.scss';

const NavHeading = ({text}) => <h2 className={styles.NavHeading}>{text}</h2>;

NavHeading.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NavHeading;



// WEBPACK FOOTER //
// ./src/components/footer/NavHeading.js